export default {
  routes: [
    // 绑定微信中间页
    {
      path: '/bindWechat/wechat',
      name: 'wechat',
      meta: {
        desc: '绑定微信中间页'
      },
      component: () => import(/* webpackChunkName: "bindWechat" */ '../views/bindWechat/wechat.vue')
    }
  ]
}
